var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1343_25533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.139 10.5935C13.7148 11.5965 13.0515 12.4803 12.2069 13.1677C11.3623 13.8551 10.3621 14.3251 9.29392 14.5367C8.2257 14.7483 7.12192 14.6949 6.07906 14.3814C5.03621 14.0678 4.08605 13.5035 3.31165 12.7379C2.53724 11.9723 1.96218 11.0287 1.63672 9.98946C1.31127 8.95026 1.24534 7.84715 1.4447 6.77659C1.64406 5.70602 2.10263 4.70058 2.78033 3.84818C3.45803 2.99578 4.33422 2.32237 5.3323 1.88683M14.6656 8.00016C14.6656 7.12468 14.4932 6.25778 14.1582 5.44894C13.8231 4.6401 13.3321 3.90517 12.713 3.28612C12.094 2.66706 11.359 2.176 10.5502 1.84097C9.74135 1.50593 8.87445 1.3335 7.99897 1.3335V8.00016H14.6656Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1343_25533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/Pie_chart.5a58db6aed92d0430f7b4a2d17e2d887.svg";
export { ForwardRef as ReactComponent };